import { ViewController, ProgressView } from "@gaming/srvg-classes-core";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";

// uses srvg.server

export class ProgressbarController extends ViewController {
    progressbar: ProgressView;

    constructor( options ) {
        options = options ||{};
        options.view = options.progressbar || null;
        super( options );
        this.name = 'progressbarController';

        this.progressbar = options.progressbar || null;
    }

    handlePhaseChangeEvent( event:PhaseChangeEvent, provider ) {
        if( event.phase.name === 'sportevent' ) {
            var max = event.phase.end - event.phase.start;
            var current = app.server.getTime() - event.phase.start;
            this.progressbar.setPosition( 1-(current/max) );
            //this.progressbar.startAnimation();
        }
        else if( event.phase.name === 'post_sportevent' ) {
            this.progressbar.clear();
        }
    }

    handleTimeoutEvent( event, provider ) {
        this.progressbar.clear();
    }
}